module.exports = __webpack_public_path__ + "static/media/pricematch.7522acd5.svg";